export const MAX_SSN_VERIFICATION_ATTEMPTS = 3;
